import { Show } from "solid-js";
import { coinIcon } from "~/assets/assets";
import { useDenominationGridContext } from "../context/denomination_grid_context";

export function DueAmount({ isCoinsOnly = false }: { isCoinsOnly?: boolean }) {
  const { externalProps, internalState } = useDenominationGridContext();
  const {
    offerConstructMaxAmount,
    offerConstructAmountUnit,
    discountPercentage,
  } = externalProps;

  const {
    dueAmount,
    redemptionAmount,
    dryRunErrorMessage: errorMessage,
    selectedAmount,
    isSimulating,
  } = internalState;

  return (
    <div class="inline-flex items-end justify-between self-stretch">
      <div class="inline-flex flex-col items-start justify-start">
        <div class="text-mediumBold text-textDark dark:text-textNormal lg:text-bold">
          {isCoinsOnly ? "Get using" : "You pay"}
        </div>
        <div
          class="inline-flex items-center justify-start gap-1"
          classList={{
            "opacity-40":
              isSimulating() ||
              selectedAmount() == null ||
              errorMessage() != null,
          }}
        >
          <Show when={isCoinsOnly}>
            <img src={coinIcon} class="h-5 w-5" />
          </Show>
          <div
            class={`text-h5 lg:text-h3`}
            classList={{
              "text-textDark": discountPercentage === 0,
              "text-[#E89901]": isCoinsOnly,
              "text-successDark": !isCoinsOnly,
            }}
          >
            {isCoinsOnly ? "" : "₹"}
            <span class="anim-due-amount">{dueAmount()}</span>
          </div>
          <Show when={discountPercentage !== 0}>
            <div class="relative h-7 w-10">
              <div class="text-base absolute left-0 top-[4px] text-textNormal line-through">
                {isCoinsOnly ? "" : "₹"}
                {redemptionAmount()}
              </div>
            </div>
          </Show>
        </div>
      </div>
      <Show when={discountPercentage !== 0 && !offerConstructMaxAmount}>
        <div class="inline-flex h-4 flex-col items-end justify-end gap-2.5 pb-1">
          <div class="inline-flex items-end justify-end gap-1 text-successDark">
            <div class="text-bold">Instant</div>
            <div class="text-bold">{discountPercentage}% off</div>
          </div>
        </div>
      </Show>
      <Show
        when={
          discountPercentage !== 0 &&
          offerConstructMaxAmount &&
          offerConstructAmountUnit === "PERC"
        }
      >
        <div class="inline-flex h-4 flex-col items-end justify-end gap-2.5 pb-1">
          <div class="inline-flex items-end justify-end gap-1 text-successDark">
            <div class="text-bold">{discountPercentage}% off </div>
            <div class="text-bold">(Max. ₹{offerConstructMaxAmount})</div>
          </div>
        </div>
      </Show>
      <Show
        when={
          discountPercentage !== 0 &&
          offerConstructMaxAmount &&
          offerConstructAmountUnit === "ABS"
        }
      >
        <div class="inline-flex h-4 flex-col items-end justify-end gap-2.5 pb-1">
          <div class="inline-flex items-end justify-end gap-1 text-successDark">
            <div class="text-bold">Instant ₹{offerConstructMaxAmount} off</div>
          </div>
        </div>
      </Show>
    </div>
  );
}
